import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function CGV() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Bouton retour */}
        <Link
          to="/"
          className="inline-flex items-center text-honey-600 hover:text-honey-700 mb-8"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Retour à l'accueil
        </Link>

        {/* Titre */}
        <h1 className="text-3xl font-bold text-slate-900 mb-8">
          Conditions Générales de Vente (CGV)
        </h1>

        {/* Contenu */}
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          {/* 1. Objet */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Objet</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Les présentes Conditions Générales de Vente (dites « CGV ») régissent les modalités d'adhésion au Syndicat Apicole de la Réunion (SAR) et à l'Association de la Maison de l'Apiculture de l'Île de la Réunion (AMAIR) via le site internet abeillereunion.re.
            </p>
            <p className="text-slate-600 leading-relaxed mt-3 text-justify">
              L'adhésion permet d'accéder aux services proposés par le SAR, notamment : informations, formations, assurances, services syndicaux, ainsi qu'à une plateforme numérique avec espace membre.
            </p>
          </section>

          {/* 2. Identification */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Identification de l'organisme</h2>
            <div className="bg-slate-50 rounded-lg p-6">
              <h3 className="font-semibold text-slate-800 mb-3">Syndicat Apicole de la Réunion (SAR)</h3>
              <p className="text-slate-600 text-sm mb-2 text-justify">
                Syndicat régi par la loi du 28 octobre 1982 (organisation catégorielle privée ayant pour but d'assurer la défense des intérêts matériels et moraux de ses membres)
              </p>
              <ul className="text-slate-600 space-y-1 mt-4">
                <li><span className="font-medium">Siège social :</span> 42 rue Alexandre Bègue, 97416 Saint-Leu</li>
                <li><span className="font-medium">SIRET :</span> 490 640 968 00015</li>
                <li><span className="font-medium">Représentant légal :</span> Pascal Faustin, vice Président</li>
                <li><span className="font-medium">Email :</span> <a href="mailto:abeillereunion@gmail.com" className="text-honey-600 hover:underline">abeillereunion@gmail.com</a></li>
                <li><span className="font-medium">Téléphone :</span> +262 692 13 45 92</li>
              </ul>
            </div>
          </section>

          {/* 3. Champ d'application */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Champ d'application</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Les présentes CGV s'appliquent à toute demande d'adhésion effectuée via la plateforme abeillereunion.re. Toute adhésion implique l'acceptation sans réserve des CGV.
            </p>
          </section>

          {/* 4. Conditions d'adhésion */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Conditions d'adhésion</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              L'adhésion est ouverte aux personnes physiques ou morales, âgées d'au moins 18 ans. Les informations fournies lors de l'adhésion doivent être exactes et à jour.
            </p>
            <p className="text-slate-600 leading-relaxed mt-3 text-justify">
              Un compte utilisateur est automatiquement créé lors de la validation de l'adhésion.
            </p>
          </section>

          {/* 5. Durée de l'adhésion */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Durée de l'adhésion</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              L'adhésion est valable jusqu'au 31 décembre de l'année en cours, quelle que soit la date d'adhésion.
            </p>
          </section>

          {/* 6. Tarifs et paiement */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Tarifs et paiement</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Le montant de l'adhésion est indiqué en euros TTC.
            </p>
            <p className="text-slate-600 leading-relaxed mt-3 text-justify">
              Le paiement est effectué en ligne, en une seule fois, via la solution sécurisée Stripe. Aucun renouvellement automatique n'est mis en place.
            </p>
          </section>

          {/* 7. Absence de droit de rétractation */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Absence de droit de rétractation et remboursement</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Conformément à l'article L221-28 du Code de la consommation, et compte tenu de la nature associative de l'adhésion, aucun remboursement ne pourra être accordé, y compris en cas de résiliation anticipée.
            </p>
          </section>

          {/* 8. Résiliation */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Résiliation</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              L'adhérent peut demander la résiliation de son adhésion à tout moment via la plateforme ou par contact direct.
            </p>
            <p className="text-slate-600 leading-relaxed mt-3 text-justify">
              Le SAR se réserve le droit de suspendre ou résilier une adhésion en cas de non-respect du statut, des règlements, des présentes CGV ou des règles acceptées lors de l'adhésion.
            </p>
          </section>

          {/* 9. Services et responsabilités */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Services et responsabilités</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Le SAR agit en tant qu'intermédiaire entre les adhérents et les groupements apicoles partenaires, juridiquement indépendants.
            </p>
            <p className="text-slate-600 leading-relaxed mt-3 text-justify">
              Le SAR ne garantit aucun résultat particulier. Les services proposés constituent des moyens mis à disposition des adhérents.
            </p>
            <p className="text-slate-600 leading-relaxed mt-3 text-justify">
              La responsabilité du SAR ne saurait être engagée en cas de dysfonctionnement technique, d'interruption temporaire du service ou de force majeure.
            </p>
          </section>

          {/* 10. Données personnelles */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Données personnelles</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Les données personnelles sont traitées conformément à la réglementation en vigueur. Les modalités complètes sont détaillées dans la{' '}
              <Link to="/politique-confidentialite" className="text-honey-600 hover:underline">
                Politique de confidentialité
              </Link>{' '}
              accessible sur le site.
            </p>
          </section>

          {/* 11. Droit applicable */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">11. Droit applicable et juridiction compétente</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Les présentes CGV sont soumises au droit français. En cas de litige, le Tribunal de Saint-Denis de La Réunion est compétent.
            </p>
          </section>
        </div>

        {/* Date de mise à jour */}
        <p className="text-sm text-slate-500 mt-6 text-center">
          Dernière mise à jour : Janvier 2026
        </p>
      </div>
    </div>
  );
}
